import { sentryCaptureError } from "@utils/sentry-utils";
import { Component } from "react";
/** Keeps a failing preview from taking the whole page down, showing the fallback instead */
// eslint-disable-next-line react/prefer-es6-class -- Error boundaries have to be class components
export class PreviewErrorBoundary extends Component {
  state = {
    hasError: false
  };
  static getDerivedStateFromError() {
    return {
      hasError: true
    };
  }
  componentDidCatch(error) {
    sentryCaptureError({
      error,
      title: "Failed to render annotation preview"
    });
  }
  render() {
    return this.state.hasError ? this.props.fallback : this.props.children;
  }
}